import ConfigActionType from '../../common/ConfigActionType';

const initialState = {
  plans: { contractTerm: '', brandName: '' },
  static: {
    lockDownEndDate: '2020-04-27T00:00:00',
    underMaintenance: false,
    covid19Mode: false,
    discountWithSubscription: {
      enabled: true,
      onOpenTerm: false,
      onFixedTerm: true
    },
    offer: {
      enabled: false
    },
    discount: {
      enabled: false
    }
  }
};

const ConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case ConfigActionType.STORE_STATIC_CONFIG:
      return { ...state, static: action.config };
    case ConfigActionType.STORE_PLANS_CONFIG:
      return { ...state, plans: action.config };
    default:
      return state;
  }
};

export const ConfigSelector = {
  getGiftWithPurchase: state =>
    state.config.static && state.config.static.offer ? state.config.static.offer : initialState.static.offer,
  getDiscountWithSubscription: state => state.config.static && state.config.static.discountWithSubscription ?
    state.config.static.discountWithSubscription : initialState.static.discountWithSubscription,
  getDiscount: state =>
    state.config.static && state.config.static.discount ? state.config.static.discount : initialState.static.discount,
  getFixTermContractTerm: state => state.config.plans.contractTerm,
  getLockDownEndDate: state => new Date(state.config.static.lockDownEndDate),
  isUnderMaintenance: state =>
    state.config.static ? state.config.static.underMaintenance : initialState.static.underMaintenance,
  isCovid19Mode: state => state.config.static.covid19Mode,
  getDelayedDaysForModemDelivery: state => parseInt(state.config.static.connectionDelayDay, 10)
};

export default ConfigReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/ConfigReducer.js
 **/